import './LineChartReport.css';
import { LineChart, d3 } from 'react-d3-components';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import ColorDetails from '../colorDetails/ColorDetails';
import { stringToNumberLocale } from '../../../helpers/formatter';
import ChartReport from '../ChartReport';
import ReportsDescription from '../reportsDescription/ReportsDescription';

class LineChartReport extends ChartReport {
  render() {
    const {
      title, width, height, data, xLabel, yLabel, formatter = f => f, inputRequired, helperMsg = '', description = null,
    } = this.props;
    const xscaleDomain = ! data || ! data.length || data === t('unableToFetchData')
      ? [] : data[0].values.map(({ x }) => x);
    const xscaleRange = ! data || ! data.length || data === t('unableToFetchData')
      ? [] : data[0].values.map((_, i) => i * (width - (width * 0.1)) / xscaleDomain.length);
    const xscale = d3.scale.ordinal().domain(xscaleDomain).range(xscaleRange);
    xscale.invert = x => xscale.domain()[d3.bisect(xscale.range(), x)];
    const descExpanded = description ? description.isExpanded : false;

    return (
      <div id={title}
        className="LineChartReport report"
        style={{
          width,
        }}
      >


        <ReportsDescription title={t(title)}
          description={description}
          width={width - (width * 0.05)}
        />
        <br />
        <br />

        { inputRequired && data && (data !== t('unableToFetchData'))

          ? ChartReport.helperMsg(width, height, helperMsg, descExpanded)

          : (
            <span>
              {! data || data === t('unableToFetchData')

                ? ChartReport.chartStatus(width, height, data)

                : (
                  <LineChart width={width}
                    height={height}
              /** there must be at least two entries to render line chart */
                    data={data.length && data[0].values.length && data[0].values.length > 1
                      ? data : {
                        label: '',
                        values: [{
                          x: '',
                          y: 0,
                        }],
                      }}
                    tooltipHtml={
                      data.length
                       && data[0].values.length
                       && data[0].values.length > 1 ? (_, { x, y }) => `${x}: ${stringToNumberLocale(formatter(y))}`
                        : undefined
                      }
                    xAxis={ChartReport.xAxis(xLabel)}
                    yAxis={ChartReport.yAxis(yLabel)}
                    xScale={data.length && data[0].values.length && data[0].values.length > 1
                      ? xscale : undefined}
                    margin={ChartReport.chartMargin()}
                    colorScale={d3.scale.category20()}
                  />
                )
          }

              {ChartReport.tooltipContainer(title)}

              { data && data.length === 0
                ? <span className="noData">{t('N/A')}</span> : ''}

              {! descExpanded && data && data.length && data !== t('unableToFetchData') && data[0].values.length === 1
                ? <span className="noData">{t('notEnoughData')}</span> : ''}

              {! data || data === t('unableToFetchData') || data.length < 2 || ! data.map || ! data[0].values.length ? null
                : (
                  <ColorDetails data={data.map(({ label, values }, index) => ({
                    color: d3.scale.category20().range()[index],
                    label,
                    values,
                  }))}
                  />
                )
          }
            </span>
          )
      }
      </div>
    );
  }

  componentDidUpdate() {
    this.generateTooltips();
  }
}

export default connect(s => s)(LineChartReport);
